import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'addDot'})
export class AddDotPipe implements PipeTransform {
    transform(value: string): string {
        return !value.endsWith('?') && !value.endsWith('.') ? value + '.' : value;
    }
}
